import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from '../../services/dashboard.service';
import {DashboardResponse} from '../model/dashboardresponse';
import { merge, Observable, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { MatSort } from '@angular/material/sort';
import { UserData } from '../model/user-data';
import { UserService } from 'src/app/services/user.service';
import { UsersDataResponse } from '../model/users-data-response';
import { Router } from '@angular/router';
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent  implements OnInit {
  dashboardsummary: DashboardResponse[] = [];
  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  

  user:UsersDataResponse;
  userData:UserData;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  constructor(private dashboardservice:DashboardService,private userservice:UserService,private router:Router) {
    this.dataSource=new MatTableDataSource<DashboardResponse>([]);
  
   }
  
  displayedColumns: string[] = ['storeordc', 'pending', 'overdue', 'late','total'];
  dataSource :MatTableDataSource<DashboardResponse>;

  ngOnInit(): void {
    this.userservice.getCurrentUser().subscribe(data=>{
      this.user=data;
      this.userData=data.userData;
      this.dataSource=new MatTableDataSource<DashboardResponse>();
      this.sort=new MatSort();
    })
    
    
  }

 

  ngAfterViewInit() {
    this.getdashboardData(this.userData.upn,this.userData.roleId);  
   this.dataSource.paginator = this.paginator;
    this.dataSource.sort=this.sort;
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
   
    
  }

  getdashboardData(upn:string,roleId:number) {

    this.dashboardservice.getDashBoardSummary(upn,roleId).subscribe(data=>{
      this.dataSource=new MatTableDataSource<DashboardResponse>(data);
    })

  }


  orderSummary(dcNumber,storeNumber){
    
    if(this.userData && this.userData.roleId>3){
    this.router.navigate(['/dcn-esign/order-summary/order-details',dcNumber]);
    }else
    if(this.userData && this.userData.roleId<4){
    this.router.navigate(['/dcn-esign/order-summary/order-details',storeNumber]);
    }
  }
}
